export const STORE_NAME = 'HeyLibby'
export const SESSION_STORE_NAME = 'HeyLibbySession'
export const LOCAL_ENV = 'local'
export const DEVELOPMENT_ENV = 'development'
export const PRODUCTION_ENV = 'production'
export const STAGING_ENV = 'staging'
export const HEY_LIBBY_SITES = [
  'localhost',
  'heylibby.ai',
  'heylibby.co',
  'heylibby.net',
  'replify.ai',
  'main.d3tfrvso00g6f0.amplifyapp.com',
  'libby-dev.com',
  'app.replify.ai',
  'app.dev.replify.ai',
  'develop.d1yqa48wwh6uoh.amplifyapp.com',
]
export const API_NAME = 'heylibbyapi'
export const API_REGEX_PATH = /(?!\/):(\w+)(?=\/?)/g
export const ENTER_KEY = 'Enter'
export const NEW_LINE = '\n'
export const URL_REGEX = /^(?!https?:\/\/)/i
export const EMAIL_REGEX =
  /^[a-zA-Z0-9.!#$%&*+=^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
export const ALPHA_NUMERIC_NO_SPACE_REGEX = /^[a-zA-Z0-9]+$/
export const ALPHA_NUMERIC_DASH_NO_SPACE_REGEX = /^[a-zA-Z0-9-]+$/
export const SMALL_CASE_LETTERS_NUMBERS_REGEX = /[^a-zA-Z0-9]/g
export const VALID_EMAIL_CHARACTERS = /^[a-zA-Z0-9.!#$%&*+=^_`{|}~-]+$/
export const MAX_UPLOAD_FILE_SIZE = 5e6
export const ONE_SECOND_IN_MS = 1_000
export const FIVE_MINUTES_IN_MS = 5 * 60 * ONE_SECOND_IN_MS
export const THIRTY_MINUTES_IN_MS = 30 * 60 * ONE_SECOND_IN_MS
export const TEN_SECONDS_IN_MS = 10 * ONE_SECOND_IN_MS
export const ALLOWED_FILE_EXTENSIONS = [
  'png',
  'webp',
  'gif',
  'jpg',
  'jpeg',
  'bmp',
]
export const BREAK_TAG_REGEX = /<br\s*\/?>/gi
export const LINK_TAG_REGEX = /<a\s+href="([^"]*)">(.*?)<\/a>/gi
export const MONTH_DAY_YEAR_FORMAT = 'MM-DD-YYYY'
export const YEAR_MONTH_DAY_FORMAT = 'YYYY-MM-DD'
export const YEAR_MONTH_DAY_DASH_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'
export const MONTH_DAY_YEAR_SLASH_FORMAT = 'MM/DD/YYYY'
export const MONTH_DAY_YEAR_TIME_SLASH_FORMAT = 'MM/DD/YYYY hh:mm A'
export const MONTH_DAY_YEAR_TIME_SLASH_FORMAT_WITH_DAY_OF_WEEK =
  'EEEE, MMMM d, hh:mm a'
export const HOUR_MINUTES_FORMAT = 'HH:mm'
export const HOUR_MINUTES_AMPM_FORMAT = 'h:mm A'
export const DEFAULT_TIMEZONE = 'UTC'
export const THREE_DIGITS_REGEX = /^\d{3}$/
export const AMERICAN_PHONE_PREFIX = '+1'
export const REMOVE_SYMBOLS_REGEX = /(?!^\+)[^0-9]/g
export const APPLY_FOR_REFERRAL_LINK =
  'https://share.hsforms.com/1ayRWkhziTMeDDrvXVkH3Cgqt2u3'
export const HEX_COLOR_REGEX = /^#[0-9A-F]{6}$/i
export const DELETE_USER_CONFIRMATION_KEY = 'delete'

export const ZAPIER_LINK = 'https://zapier.com'
export const TRANSPARENT_IMAGE =
  'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
export const CALENDLY_WHITELABEL_LINK =
  'https://calendly.com/heylibby/discuss-heylibby-white-label'
export const DEFAULT_STALE_TIME = 10 * ONE_SECOND_IN_MS
export const CALENDLY_SCHEDULE_MEETING_LINK =
  'https://calendly.com/heylibby/meeting-with-heylibby'
export const HUBSPOT_TCR_FORM_SRC =
  'https://js-na2.hsforms.net/forms/embed/developer/45026715.js'
export const HUBSPOT_PORTAL_ID = '45026715'
export const HUBSPOT_TCR_FORM_ID = '98aad9d7-e463-48f5-a63f-88d4d216a0f8'
export const MARKETING_SITE_URL = 'https://replify.ai'

export const MONTH_DAY_FORMAT = 'MMM dd'
export const MONTH_DAY_YEAR_COMMA_FORMAT = 'MMM dd, yyyy'

export const TOTAL_CONVERSATIONS_TOOLTIP =
  'Counts engaged conversations only: at least two back-and-forth messages across channels'

export const QUALIFIED_LEADS_TOOLTIP =
  'Number of contacts marked Qualified using your criteria in Analysis Settings'

export const TOTAL_CALLS_TOOLTIP = 'Total # of calls answered by your assistant'

// Remove this var once we don't need the code anymore
export const HIDE_PHONE_MIGRATION = true
